import { createActionType } from "Common/namespaceUtils/namespaceRedux";
import { FULL_NAMESPACE } from "../constants";
export default {
    GET_WORK_SPACE: createActionType(FULL_NAMESPACE, "GET_WORK_SPACE"),
    GET_WORK_SPACE_COMPLETED: createActionType(FULL_NAMESPACE, "GET_WORK_SPACE_COMPLETED"),
    SET_TAB: createActionType(FULL_NAMESPACE, "SET_TAB")
};
